import type { Alias } from '#shared/api/schema';
import { CONSTRUCTOR_GIFT_PAGES } from '../constants';

export const isConstructorPageGiftCard = (alias: Alias) => alias && CONSTRUCTOR_GIFT_PAGES.includes(alias);
